import { ModalCustom } from "components/ModalCustom";
import {
  ContainerMensagem,
  ContainerObservacao,
  Icone,
  ModalBody,
} from "./style";
import { FaCheck } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
}

export function ModalSucessoEnviarParaCorrecao({ show, handleClose }: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Solicitar correção de lote"
      centered={true}
      footer={false}
      footerConfirmButton={false}
    >
      <ModalBody>
        <Icone>
          <FaCheck />
        </Icone>
        <ContainerMensagem>
          Solicitação realizada com sucesso!
        </ContainerMensagem>
        <ContainerObservacao>
          O lote foi movido para a aba "Aguardando aprovação"
        </ContainerObservacao>
      </ModalBody>
    </ModalCustom>
  );
}
